'use strict';

function GrowlDirective () {
  return {
    scope: false,
    controller: 'GrowlController',
    controllerAs: 'growlController',
    restrict: 'A',
    templateUrl: 'growl.tpl.html'
  };
}

module.exports = GrowlDirective;



//////////////////
// WEBPACK FOOTER
// ./~/@skycatch/saturn-growl-booster/src/GrowlDirective.js
// module id = 769
// module chunks = 0